"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const RequiredOptionItem_1 = require("./RequiredOptionItem");
class RequiredOption {
    constructor({ name, amount, points }) {
        this.toJSON = () => ({
            name: this.name,
            amount: this.amount,
            points: this.points,
        });
        this.name = name;
        this.amount = amount;
        this.points = points;
    }
}
RequiredOption.fromJSON = (json) => {
    const { name, amount, points } = Object.assign({}, json);
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (typeof amount !== 'number' || Number.isNaN(amount))
        throw new Error('.amount must be a number');
    if (!Array.isArray(points))
        throw new Error('.points must be an array');
    return new RequiredOption({
        name,
        amount,
        points: immutable_1.List(points.map((_point) => RequiredOptionItem_1.default.fromJSON(_point))),
    });
};
exports.default = RequiredOption;
